module.exports = __webpack_public_path__ + "static/media/plan-pgbl.36393288.png";